import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import PageCard from '../../../common/PageCard'
import VerificationCodeInput from '../../../common/VerificationCodeInput'
import { Button } from 'antd'
import $t from '../../../../i18n'
import Page from '../../../common/Page'

import './VerifySSNCode.css'
import { event, eventTypes } from '../../../../consts/eventConsts'

const VerifySSNCode = () => {
  const dispatch = useDispatch()
  const signupFormErrorMessage = useSelector(
    state => state.signup?.signupFormErrorMessage
  )
  const userSignup = useSelector(state => state.signup?.userSignup)

  const [ssnCode, setCode] = useState('')

  const handleNext = () => {
    dispatch(
      Actions.createAction(Actions.VERIFY_SSN_HMO_FIRST_LOGIN_REQUESTED, {
        ssnCode,
      })
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.formEvent,
        eventName: event.formEvent.submit,
        data: { userSignup },
        element: 'next ssn',
      })
    )
  }

  return (
    <PageCard className="login-page-card ssn-code-page-card">
      <Page
        className="login-page ssn-code-page"
        hideAlertBanner={true}
        title={$t('pages.getStarted.signupForm.ssnCodePage.title')}
        subtitle={$t('pages.getStarted.signupForm.ssnCodePage.subtitle')}
      >
        <VerificationCodeInput
          className="verify-ssn-code-input"
          fields={4}
          onChange={v => {
            setCode(v)
          }}
        />
        {signupFormErrorMessage && (
          <div className="signup-server-errors">{signupFormErrorMessage}</div>
        )}
        <Button type="primary" onClick={handleNext}>
          {$t('common.next')}
        </Button>
      </Page>
    </PageCard>
  )
}

export default VerifySSNCode
